import React from 'react';
import { xconnect } from '../../redux/xconnect';
import II18 from '../translate/II18';
import PropTypes from 'prop-types';
import { f7 } from 'framework7-react';
import {
  EXTERNAL_POPUP_WINDOW_STATUS,
  SET_EXTERNAL_POPUP_WINDOW_OPEN
} from '../../redux/actions/rootAction';
import { gae } from './Analytics';
import { popupDiagLabel } from '../formsCommon/esignatures/utils';

export default function withExternalPopupWindow(WrappedComponent) {
  // noinspection JSPotentiallyInvalidUsageOfThis
  class WrapperClass extends React.Component {
    componentDidMount() {
      const thiss = this;

      // loading.html (same-origin) reports unload/hide before win.closed flips.
      this._onExtPopupMessage = event => {
        if (event.origin !== window.location.origin) return;
        const data = event.data;
        if (!data || data.source !== 'paperfly-ext-popup') return;
        gae(
          'EXTERNAL_POPUP',
          `CHILD_${String(data.event || 'msg').toUpperCase()}`,
          `name=${data.name || ''}|persisted=${
            data.persisted ? '1' : '0'
          }|href=${data.href || ''}`
        );
      };
      window.addEventListener('message', this._onExtPopupMessage);

      this.props.onPropChange('externalPopUpStatus', newProps => {
        if (
          newProps.externalPopUpStatus === EXTERNAL_POPUP_WINDOW_STATUS.CLOSE
        ) {
          const popupWindow = newProps.externalPopUpOptions?.winReference;
          gae('EXTERNAL_POPUP', 'TRY_TO_CLOSE', popupDiagLabel(popupWindow));
          if (popupWindow && !popupWindow.closed) {
            gae('EXTERNAL_POPUP', 'CALL_CLOSE', popupDiagLabel(popupWindow));
            popupWindow.close();
          } else {
            gae(
              'EXTERNAL_POPUP',
              'CANT_CLOSE',
              popupDiagLabel(
                popupWindow,
                popupWindow ? 'reason=already_closed' : 'reason=no_reference'
              )
            );
          }
        }

        if (
          newProps.externalPopUpStatus === EXTERNAL_POPUP_WINDOW_STATUS.PREPARE
        ) {
          let win = newProps.externalPopUpOptions.winReference;
          const winType = newProps.externalPopUpOptions?.winType;

          if (!win || win.closed || typeof win.closed == 'undefined') {
            gae(
              'EXTERNAL_POPUP',
              'PREPARE_FAIL',
              popupDiagLabel(win, `type=${winType || ''}`)
            );
            f7.dialog.alert(
              II18.get(thiss.props.externalPopUpOptions.popupFailMessage),
              II18.get('signme_settings_nopopup_title')
            );
            this.props.callAction(
              SET_EXTERNAL_POPUP_WINDOW_OPEN,
              EXTERNAL_POPUP_WINDOW_STATUS.CLOSE
            );
            return;
          }

          gae(
            'EXTERNAL_POPUP',
            'WATCH_START',
            popupDiagLabel(win, `type=${winType || ''}`)
          );
          this.props.callAction(
            SET_EXTERNAL_POPUP_WINDOW_OPEN,
            EXTERNAL_POPUP_WINDOW_STATUS.OPEN
          );

          // Watch this specific Window; ignore if a newer prepare replaced it
          // (e.g. ATRUST WebID closed then sign popup opened under the same name).
          const timer = setInterval(function() {
            if (!win || win.closed) {
              const stillCurrent =
                thiss.props.externalPopUpOptions?.winReference === win;
              gae(
                'EXTERNAL_POPUP',
                'WATCH_DETECTED_CLOSED',
                popupDiagLabel(
                  win,
                  `current=${stillCurrent ? '1' : '0'}|type=${winType || ''}`
                )
              );
              if (stillCurrent) {
                thiss.props.callAction(
                  SET_EXTERNAL_POPUP_WINDOW_OPEN,
                  EXTERNAL_POPUP_WINDOW_STATUS.CLOSE
                );
              }
              clearInterval(timer);
            }
          }, 500);
        }
      });
    }

    componentWillUnmount() {
      if (this._onExtPopupMessage) {
        window.removeEventListener('message', this._onExtPopupMessage);
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  WrapperClass.propTypes = {
    callAction: PropTypes.func,
    onPropChange: PropTypes.func,
    externalPopUpStatus: PropTypes.any,
    externalPopUpOptions: PropTypes.object
  };

  const mapStateToProps = (state, ownProps) => {
    return {
      externalPopUpStatus: state.externalPopUpStatus,
      externalPopUpOptions: state.externalPopUpOptions
    };
  };

  return xconnect(mapStateToProps)(WrapperClass);
}
